// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".payment-history-title[data-v-72bdd99d]{color:#032f61;font-weight:600;padding:10px 0 10px 0;font-size:14px}@media (min-width: 1200px){.payment-history-title[data-v-72bdd99d]{font-size:16px}}\n", ""]);
// Exports
module.exports = exports;
